import { ArrowRight } from 'lucide-react'
import type { PropsWithChildren } from 'react'
import { Link } from 'react-router-dom'

interface ButtonProps extends PropsWithChildren {
  to: string
  variant?: 'primary' | 'secondary' | 'ghost'
  className?: string
  arrow?: boolean
}

export function Button({ to, children, variant = 'primary', className = '', arrow = false }: ButtonProps) {
  const styles = {
    primary: 'bg-brand text-[#15100a] hover:bg-brand-light shadow-[0_10px_30px_rgba(223,163,68,.16)]',
    secondary: 'border border-white/12 bg-white/[.035] text-white hover:border-white/20 hover:bg-white/[.065]',
    ghost: 'text-zinc-300 hover:text-white',
  }
  const classes = `group inline-flex min-h-11 items-center justify-center gap-2 rounded-[10px] px-5 text-sm font-semibold transition duration-300 ${styles[variant]} ${className}`
  const content = <>{children}{arrow && <ArrowRight size={16} strokeWidth={1.8} aria-hidden="true" className="transition-transform duration-200 group-hover:translate-x-0.5" />}</>

  return /^https?:\/\//.test(to)
    ? <a href={to} className={classes}>{content}</a>
    : <Link to={to} className={classes}>{content}</Link>
}
